<script>
  import ClickOutside from 'svelte-click-outside';
  import {__} from '../../utils/i18n';

  export let phoneNumber; 
  export let emailAddress; 
  export let website; 


  let button;
  let showDropdown = false;

  const dashedPhoneNumber = (d) => {
    // following ap style, returns xxx-xxx-xxxx
    // just in case, remove everything that is not a number first
    let cleanNumber = phoneNumber;
    let formattedNumber =
      '(' +
      cleanNumber.slice(0, 3) +
      ') ' +
      cleanNumber.slice(3, 6) +
      '-' +
      cleanNumber.slice(6);
    return String(formattedNumber);
  };

  function onToggle() {
    showDropdown = !showDropdown; 
  }

  function onClickOutside() {
    showDropdown = false;
  }
</script>


<div class="contact">
  <button bind:this={button} class="action" on:click={onToggle}>{__("Contact")}</button>

  {#if showDropdown}
    <ClickOutside on:clickoutside={onClickOutside} exclude={[button]}>
      <ul class="dropdown" class:show={showDropdown}>
        {#if phoneNumber}
          <li>
            <a href="tel:+1{phoneNumber}">
              <svg role="img" id="phone-icon-svg" alt="{__('Phone icon')}" aria-label="{__('Select to call representative')}">
                <use xlink:href="#phone-icon" />
              </svg>
              <span>{dashedPhoneNumber(phoneNumber)}</span>
            </a>
          </li>
        {/if}
        {#if emailAddress}
          <li>
            <a href="mailto:{emailAddress}">
              <svg role="img" id="mail-icon-svg" alt="{__('Envelope icon')}" aria-label="{__('Select to email representative')}">
                <use xlink:href="#mail-icon" />
              </svg>
              <span>{emailAddress}</span>
            </a>
          </li>
        {/if}
        {#if website}
          <li>
            <a href="{website}">
              <svg role="img" id="form-icon-svg" alt="{__('Form icon')}" aria-label="{__('Select to go to representative site')}">
                <use xlink:href="#form-icon" />
              </svg>
              <span>via website</span>
            </a>
          </li>
        {/if}
      </ul>
    </ClickOutside>
  {/if}

</div>
  

